import ApiCaller from "./apiCaller";
export const fetchUserProfile = () => ApiCaller.get("userme/me");

export const updateUserPreference = (key: string, value: any) =>
  ApiCaller.post("user/preference", {
    preference_key: key,
    preference_value: value,
  });

export const getUserPreference = () => ApiCaller.get("user/preference");
